import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { createActions } from '@manager-base/app-base/config/data-access';

const actions = {
    validate: {
        method: 'GET',
        url: `${BASE_PATH_API}/emailValidation/validate?email=:email`
    }
};

export function MailgunApi(
    HTTP_STATUS_CODES,
    $q,
    MailgunService
) {
    const service = createActions(actions);

    service.check = function check(value, ctrl, elem) {
        let validatedValue;
        const deferred = $q.defer();

        if (!value) return $q.resolve();

        // run validator once
        if (value !== validatedValue || !ctrl.$error.valTypeEmail) {
            validatedValue = value;

            service.validate({ email: encodeURIComponent(value) })
                .then((response, status) => {
                    // mailgun is down don't block users
                    if (status !== HTTP_STATUS_CODES.OK) {
                        return deferred.resolve();
                    }

                    // fails validation is mailgun says email doesn't exist
                    if (!response.is_valid && !response.did_you_mean) {
                        const message = 'Email address doesn\'t exist';
                        MailgunService.clearSuggestions();
                        ctrl.$validators.mailGunGuard.validationMessage = message;
                        ctrl.$setViewValue(validatedValue);

                        return deferred.reject(message);
                    }

                    // add suggestion if provided
                    if (response.did_you_mean) {
                        const message = response.did_you_mean;
                        MailgunService.emailSuggestion(elem, message, ctrl);
                        return deferred.resolve();
                    }

                    // fail safely
                    return deferred.resolve();
                })
                .catch(() => deferred.resolve());
        }

        return deferred.promise;
    };

    return service;
}

MailgunApi.$inject = [
    'HTTP_STATUS_CODES',
    '$q',
    'MailgunService'
];
